module.exports = __webpack_public_path__ + "img/ticket-purchase-confirmation.a4dc30e4.svg";